export default __webpack_public_path__ + "static/media/projects_img.a27597d5.png";